<template>

  <div
    class="posts-js-wrapper js-feed-container"
    :class="{ 'more-posts-loader':parseInt(moduleSettings.show_more_btn) == 1}"
  >

      <ErrorMsg v-if="error" :error="error" />

      <LoadingSpinner v-if="fetching == true" :fetchingMore="fetchingMore" />

      <PostsLoop
          v-if="fetching == false && Object.keys(posts).length > 0"
          :posts="posts"
          :moduleSettings="moduleSettings"
          />

      <div v-if="hasMore && parseInt(moduleSettings.show_more_btn) == 1 && !fetchingMore && !fetching" class="js-feed-load-more-container">
        <button class="btn-default btn-primary" @click="fetchMore">{{ moduleSettings.more_btn_text }}</button>
      </div>

      <LoadingSpinner v-if="fetchingMore == true" :fetchingMore="fetchingMore" />

  </div>

</template>

<script>
// import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
import LoadingSpinner from './components/LoadingSpinner.vue'
import ErrorMsg from './components/ErrorMsg.vue'
import PostsLoop from './components/PostsLoop.vue'

export default {
  data: function () {
    return {
      fetching: true,
      fetchingMore: false,
      posts: {},
      maxPosts: {},
      complete: {},
      error: false,
      nodeId: this.nodeModuleId,
      moduleSettings: this.initialModuleSettings
    }
  },
  props: {
    initialModuleSettings: {
      type: Object
    },
    nodeModuleId: {
      type: String
    },
    modLo: {
      type: Boolean
    },
    isEditing: {
      type: Boolean
    }
  },
  components: {
    LoadingSpinner,
    ErrorMsg,
    PostsLoop
  },
  computed: {
    hasMore: function () {
      if (Object.keys(this.complete).length > 0) {
        for (let index in this.complete) {
          if (this.complete[index] === false) {
            return true
          }
        }
      }
      return false
    }
  },
  methods: {
    fetchMore: function () {
      const fetchMore = true
      this.fetchingMore = true
      this.getPosts(fetchMore)
    },
    getPosts: function (fetchMore = false, editing = false) {
      const vm = this
      const moduleSettings = this.moduleSettings
      let results = !editing ? vm.posts : {}
      let postCount = 0
      let complete = !editing ? vm.complete : {}
      let maxPosts = !editing ? vm.maxPosts : {}

      function fetchAllPosts () {
        let fetchArray = []

        const fetchBatch = (source, index) => {
          if (typeof complete[index] === 'undefined' || complete[index] === false) {
            postCount = typeof results[index] !== 'undefined' ? results[index].length : 0
            let perPage = source.posts_per_page
            let newOffset = fetchMore ? postCount : parseInt(source.offset)
            let newCategories = source.categories ? '&categories=' + source.categories : ''
            let newTags = source.tags ? '&tags=' + source.tags : ''
            let newAihe = source.aihe ? '&aihe=' + source.aihe : ''
            let newUutisenAvainsana = source['uutisen-avainsana'] ? '&uutisen-avainsana=' + source['uutisen-avainsana'] : ''
            let newSearch = source.search ? '&search=' + source.search : ''
            let newSlugs = source.slug ? '&slug=' + source.slug : ''
            let newInclude = source.include ? '&include=' + source.include : ''
            if (source.posts_post.length > 0) {
              newInclude = '&include=' + source.posts_post
            }
            let newExclude = source.exclude ? '&exclude=' + source.exclude : ''
            let newOrderby = '&orderby' + moduleSettings.orderby + '&order=' + moduleSettings.order.toLowerCase()
            let newLang = source.lang

            return axios.get(source.feed_source + '?per_page=' + perPage + '&lang=' + newLang + '&offset=' + newOffset + newOrderby + newCategories + newTags + newAihe + newUutisenAvainsana + newSearch + newSlugs + newInclude + newExclude)
              .then((response) => {
                return response
              })
              .catch(error => {
                return error.response
              })
          } else {
            return false
          }
        }
        moduleSettings.sources.forEach((source, index) => {
          fetchArray.push(fetchBatch(source, index))
        })
        return Promise.all(fetchArray)
      }

      return fetchAllPosts().then((allResults) => {
        allResults.forEach((item, index) => {
          if (item && item.status === 200 && typeof item.data === 'object') {
            results = typeof results[index] === 'undefined' ? Object.assign({}, results, { [index]: item.data }) : Object.assign({}, results, { [index]: results[index].concat(item.data) })
            maxPosts = Object.assign({}, maxPosts, { [index]: parseInt(item.headers['x-wp-total']) })
            complete = Object.assign({}, complete, { [index]: !(results[index].length < maxPosts[index]) })
            this.error = false
          } else {
            this.error = item
            this.posts = {}
          }
        })

        this.posts = results
        this.complete = complete
        this.maxPosts = maxPosts
        this.fetching = false
        this.fetchingMore = false
      })
    },
    settingsUpdateHandler: function () {
      let targetName = null
      let newValue = null
      let vm = this

      document.addEventListener('keyup', function (e) {
        // Get target input name
        targetName = e.target.name

        // Do not update style & attribute settings generated by beaver builder
        if (
          targetName === 'post_padding' ||
            targetName === 'post_spacing' ||
            targetName === 'post_columns' ||
            targetName === 'post_columns' ||
            targetName === 'info_font_size' ||
            targetName === 'content_font_size' ||
            targetName === 'title_font_size' ||
            targetName === 'border_size' ||
            targetName === 'class' ||
            targetName === 'container_element'
        ) return

        // Get module settings parent
        const parentNode = document.getElementsByClassName('fl-builder-settings')
        if (typeof parentNode[0] === 'undefined') return

        // Get module node id to target the correct vue instance
        const settingsNodeId = 'v-posts-feed-' + parentNode[0].dataset.node // == beaver builder module id

        const parentNodeDataType = parentNode[0].dataset.type // == custom-posts-feed
        const childSettingsDataType = parentNode.length > 1 ? parentNode[1].dataset.type : null // == feed_sources_form | null

        let defaultSettings = null

        // Get the correct form index - is user editing the general settings or the sources settings?
        const formIndex = childSettingsDataType === 'feed_sources_form' ? 1 : 0

        // Beaver builder settings input should be in the last element
        const count = parentNode[formIndex].length - 1
        if (parentNode[formIndex][count].className === 'fl-builder-settings-json') {
          defaultSettings = parentNode[formIndex][count].value
        } else {
          // If not, loop through the nodes to find the settings input
          for (let i = 0; i < parentNode[formIndex].length; i++) {
            if (parentNode[formIndex][i].className === 'fl-builder-settings-json') {
              defaultSettings = parentNode[formIndex][i].value
            }
          }
        }

        // Settings value to JSON
        if (defaultSettings) {
          defaultSettings = JSON.parse(defaultSettings)
        }

        // Get the new value
        newValue = e.target.value

        //  Update settings if
        // - there is a settings option with the name of the input field
        // - the module nodeId matches the module currently being edited (avoids updating all instances)
        if (settingsNodeId === vm.nodeId && newValue) {
          if (childSettingsDataType === 'feed_sources_form') {
            for (let i = 0; i < vm.moduleSettings.sources.length; i++) {
              if (
                typeof vm.moduleSettings.sources[i][targetName] !== 'undefined' &&
                  (vm.moduleSettings.sources[i].label === defaultSettings.label || vm.moduleSettings.sources[i].feed_source === defaultSettings.feed_source) &&
                  vm.moduleSettings.sources[i][targetName] !== newValue
              ) {
                vm.moduleSettings.sources[i][targetName] = newValue
              }
            }
          }

          if (parentNodeDataType === 'custom-posts-feed') {
            if (typeof vm.moduleSettings[targetName] !== 'undefined' && vm.moduleSettings[targetName] !== newValue) {
              vm.moduleSettings[targetName] = newValue
            }
          }
        }
      }, false)

      document.addEventListener('click', function (e) {
        // Get the parent node
        const parentNode = document.querySelector('.fl-builder-settings')

        // Proceed only if the clicked element type is "select"
        if (!parentNode && e.target.tagName !== 'SELECT') return

        // Get the module node id of the module currently being edited
        const settingsNodeId = 'v-posts-feed-' + parentNode.dataset.node

        targetName = e.target.name
        newValue = e.target.value

        // Proceed if
        // - there is a settings option with the name of the input field
        // - the module node id and nodeId matches
        if (
          typeof vm.moduleSettings[targetName] !== 'undefined' &&
            settingsNodeId === vm.nodeId &&
            targetName
        ) {
          // Update the settings value
          vm.moduleSettings[targetName] = newValue
        }
      }, false)
    }
  },
  created () {
    this.getPosts()

    if (this.modLo === true && this.isEditing === true) {
      this.settingsUpdateHandler()
    }
  }
}

</script>

<style lang="scss">

</style>
